import React, { useState, useEffect } from 'react'
import { serbaUsahaService } from '../../services/serbaUsahaService'

function DaftarTransaksi() {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [status, setStatus] = useState('')
  const [jenis, setJenis] = useState('')
  const [tglAwal, setTglAwal] = useState('')
  const [tglAkhir, setTglAkhir] = useState('')
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [detail, setDetail] = useState(null)

  const fetchData = async () => {
    try {
      setLoading(true)
      const res = await serbaUsahaService.getTransaksi({
        status: status || undefined, jenis: jenis || undefined,
        tglAwal: tglAwal || undefined, tglAkhir: tglAkhir || undefined,
        page, limit: 20
      })
      setData(res.data.data || [])
      setTotalPages(res.data.meta?.totalPages || 1)
    } catch (err) { console.error(err) }
    finally { setLoading(false) }
  }

  useEffect(() => { fetchData() }, [page, status, jenis, tglAwal, tglAkhir])

  const formatCurrency = (val) => new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(val || 0)

  const formatDate = (d) => {
    if (!d) return '-'
    const dt = new Date(d)
    return dt.toLocaleDateString('id-ID', { year: 'numeric', month: 'short', day: 'numeric' })
  }

  const handleDetail = async (no) => {
    try {
      const res = await serbaUsahaService.getTransaksiDetail(no)
      setDetail(res.data.data)
    } catch { alert('Gagal mengambil detail') }
  }

  return (
    <div className="card">
      <div className="card-header"><h3 className="card-title">Daftar Transaksi</h3></div>
      <div className="card-body">
        <div className="row mb-3">
          <div className="col-md-2">
            <select className="form-control" value={status} onChange={e => { setStatus(e.target.value); setPage(1) }}>
              <option value="">Semua Status</option>
              <option value="Lunas">Lunas</option>
              <option value="BelumLunas">Belum Lunas</option>
              <option value="Dibatalkan">Dibatalkan</option>
            </select>
          </div>
          <div className="col-md-2">
            <select className="form-control" value={jenis} onChange={e => { setJenis(e.target.value); setPage(1) }}>
              <option value="">Semua Jenis</option>
              <option value="Tunai">Tunai</option>
              <option value="Kredit">Kredit</option>
            </select>
          </div>
          <div className="col-md-2">
            <input type="date" className="form-control" value={tglAwal} onChange={e => { setTglAwal(e.target.value); setPage(1) }} placeholder="Dari tgl" />
          </div>
          <div className="col-md-2">
            <input type="date" className="form-control" value={tglAkhir} onChange={e => { setTglAkhir(e.target.value); setPage(1) }} placeholder="Sampai tgl" />
          </div>
        </div>

        {loading ? <div className="text-center py-3"><i className="fas fa-spinner fa-spin fa-2x"></i></div> : (
          <table className="table table-bordered table-hover">
            <thead><tr>
              <th>No. Transaksi</th><th>Tgl</th><th>Jenis</th><th>Anggota</th><th>Total</th><th>Sisa</th><th>Status</th><th>Aksi</th>
            </tr></thead>
            <tbody>
              {data.length === 0 ? <tr><td colSpan="8" className="text-center">Tidak ada data</td></tr> :
                data.map((t, i) => (
                  <tr key={i}>
                    <td>{t.NoTransaksi}</td>
                    <td>{formatDate(t.TglTransaksi)}</td>
                    <td><span className={`badge ${t.JenisTransaksi === 'Kredit' ? 'badge-warning' : 'badge-info'}`}>{t.JenisTransaksi}</span></td>
                    <td>{t.NamaAnggota || t.Nama || '-'}</td>
                    <td className="text-right">{formatCurrency(t.TotalHarga)}</td>
                    <td className="text-right">{t.JenisTransaksi === 'Kredit' ? formatCurrency(t.SisaPembayaran) : '-'}</td>
                    <td>{t.Status === 'Lunas' ? <span className="badge badge-success">Lunas</span> :
                       t.Status === 'BelumLunas' ? <span className="badge badge-warning">Belum Lunas</span> :
                       <span className="badge badge-danger">Dibatalkan</span>}</td>
                    <td><button className="btn btn-sm btn-info" onClick={() => handleDetail(t.NoTransaksi)}><i className="fas fa-eye"></i></button></td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}

        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-3">
            {Array.from({ length: totalPages }, (_, i) => (
              <button key={i} className={`btn btn-sm ${page === i + 1 ? 'btn-primary' : 'btn-default'} mx-1`} onClick={() => setPage(i + 1)}>{i + 1}</button>
            ))}
          </div>
        )}
      </div>

      {detail && (
        <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Detail Transaksi: {detail.NoTransaksi}</h5>
                <button type="button" className="close" onClick={() => setDetail(null)}>&times;</button>
              </div>
              <div className="modal-body">
                <div className="row mb-3">
                  <div className="col-md-6"><strong>Tgl:</strong> {formatDate(detail.TglTransaksi)}</div>
                  <div className="col-md-6"><strong>Jenis:</strong> {detail.JenisTransaksi}</div>
                  <div className="col-md-6"><strong>Anggota:</strong> {detail.NamaAnggota || detail.Nama || '-'}</div>
                  <div className="col-md-6"><strong>Status:</strong> {detail.Status}</div>
                </div>
                <h6>Item Barang</h6>
                <table className="table table-sm table-bordered">
                  <thead><tr><th>Barang</th><th>Qty</th><th>Harga</th><th>Subtotal</th></tr></thead>
                  <tbody>
                    {detail.details?.map((d, i) => (
                      <tr key={i}>
                        <td>{d.NamaBarang}</td>
                        <td className="text-center">{d.Qty}</td>
                        <td className="text-right">{formatCurrency(d.HargaSatuan)}</td>
                        <td className="text-right">{formatCurrency(d.SubTotal)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot><tr className="font-weight-bold"><td colSpan="3">Total</td><td className="text-right">{formatCurrency(detail.TotalHarga)}</td></tr></tfoot>
                </table>
                {detail.pembayaran?.length > 0 && (
                  <>
                    <h6>Riwayat Pembayaran</h6>
                    <table className="table table-sm table-bordered">
                      <thead><tr><th>#</th><th>Tgl</th><th>Jumlah</th><th>Sisa</th><th>Status</th></tr></thead>
                      <tbody>
                        {detail.pembayaran.map((p, i) => (
                          <tr key={i}>
                            <td>{p.AngsuranKe}</td>
                            <td>{formatDate(p.TglBayar)}</td>
                            <td className="text-right">{formatCurrency(p.JumlahBayar)}</td>
                            <td className="text-right">{formatCurrency(p.SisaSetelah)}</td>
                            <td>{p.Status}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                )}
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setDetail(null)}>Tutup</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
export default DaftarTransaksi
